import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function PlayFilledIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...size !== undefined && { width: size, height: size }}
			{...props}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M5.45398 5.7895C5.45398 4.42044 6.95518 3.58158 8.12115 4.2991L18.2131 10.5095C19.3236 11.1929 19.3236 12.807 18.2131 13.4903L8.12115 19.7007C6.95518 20.4183 5.45398 19.5794 5.45398 18.2103V5.7895Z"
				fill="currentColor"
			/>
		</svg>
	);
}

PlayFilledIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default PlayFilledIcon;
